/**
 * Created by chachora on 12/12/18.
 */
import { Dispatch, AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import * as stApi from '../api/station-tools-api';
import AuthHelper from '../helpers/auth-helper';
import { resetAppState as resetStoreState } from './index';
import { RootState } from './reducers';

export const USER_LOGOUT = 'USER_LOGOUT';

// TODO add login action

export const logout =
  (): ThunkAction<Promise<void>, RootState, unknown, AnyAction> =>
  async (dispatch: Dispatch<AnyAction>) => {
    try {
      await stApi.logout();
      resetAppState(dispatch);
    } catch (err) {
      throw err;
    }
  };

export const resetAppState = (dispatch: Dispatch<AnyAction>): void => {
  try {
    AuthHelper.removeToken();
    resetStoreState(dispatch);
  } catch (err) {
    throw err;
  }
};
